/**
 * Country SEO i18n — Wave 37
 * Fills final gaps: south-africa (pl), saudi-arabia-expanded (13 languages),
 * scandinavia (missing languages), and verifies china completeness.
 */
import type { CountrySEOMap } from './country-seo-i18n-types';

export const COUNTRY_SEO_I18N_WAVE37: CountrySEOMap = {

  // ============ SOUTH AFRICA — fill PL gap ============
  'south-africa': {
    pl: {
      title: 'Call Center RPA | Outsourcing Obsługi Klienta | Call IT Dev',
      description: 'Call center dla RPA: anglojęzyczni agenci, CSAT 95%, od 3 $/h. 60% oszczędności vs Johannesburg.',
      heroTitle: 'Call Center dla Republiki Południowej Afryki',
      heroSubtitle: 'Premium obsługa klienta po angielsku dla rynku południowoafrykańskiego.',
    },
  },

  // ============ SAUDI ARABIA EXPANDED (KSA) — fill 13 missing languages ============
  'saudi-arabia-expanded': {
    de: {
      title: 'Callcenter KSA | Arabischsprachiger Kundenservice Vision 2030 | Call IT Dev',
      description: 'Callcenter für Saudi-Arabien KSA: arabische Muttersprachler, CSAT 95%, Vision 2030-konform, ab 5 $/h.',
      heroTitle: 'Callcenter für KSA — Vision 2030 Support',
      heroSubtitle: 'Premium arabischer Kundenservice für den saudischen Markt. Vision 2030-konform.',
    },
    es: {
      title: 'Call Center KSA | Centro de Llamadas Arabia Saudita Visión 2030 | Call IT Dev',
      description: 'Call center para Arabia Saudita KSA: agentes árabes nativos, CSAT 95%, compatible Visión 2030, desde 5 $/h.',
      heroTitle: 'Call Center para KSA — Soporte Visión 2030',
      heroSubtitle: 'Servicio al cliente premium en árabe para el mercado saudí.',
    },
    it: {
      title: 'Call Center KSA | Centro Chiamate Arabia Saudita Vision 2030 | Call IT Dev',
      description: 'Call center per Arabia Saudita KSA: agenti arabi madrelingua, CSAT 95%, Vision 2030, da 5 $/h.',
      heroTitle: 'Call Center per KSA — Supporto Vision 2030',
      heroSubtitle: 'Assistenza clienti premium in arabo per il mercato saudita.',
    },
    pt: {
      title: 'Call Center KSA | Central Atendimento Arábia Saudita Visão 2030 | Call IT Dev',
      description: 'Call center para Arábia Saudita KSA: agentes árabes nativos, CSAT 95%, Visão 2030, a partir de 5 $/h.',
      heroTitle: 'Call Center para KSA — Suporte Visão 2030',
      heroSubtitle: 'Atendimento premium em árabe para o mercado saudita.',
    },
    nl: {
      title: 'Callcenter KSA | Arabischtalige Klantenservice Vision 2030 | Call IT Dev',
      description: 'Callcenter voor Saoedi-Arabië KSA: Arabische moedertaalsprekers, CSAT 95%, Vision 2030, vanaf 5 $/u.',
      heroTitle: 'Callcenter voor KSA — Vision 2030 Support',
      heroSubtitle: 'Premium Arabische klantenservice voor de Saoedische markt.',
    },
    pl: {
      title: 'Call Center KSA | Obsługa Klienta Arabia Saudyjska Wizja 2030 | Call IT Dev',
      description: 'Call center dla Arabii Saudyjskiej KSA: arabskojęzyczni agenci, CSAT 95%, Wizja 2030, od 5 $/h.',
      heroTitle: 'Call Center dla KSA — Wsparcie Wizja 2030',
      heroSubtitle: 'Premium obsługa klienta po arabsku dla rynku saudyjskiego.',
    },
    tr: {
      title: 'KSA Çağrı Merkezi | Suudi Arabistan Vizyon 2030 | Call IT Dev',
      description: 'Suudi Arabistan KSA çağrı merkezi: anadil Arapça, CSAT %95, Vizyon 2030, 5 $/saatten.',
      heroTitle: 'KSA Çağrı Merkezi — Vizyon 2030 Desteği',
      heroSubtitle: 'Suudi pazarı için premium Arapça müşteri hizmetleri.',
    },
    sv: {
      title: 'Callcenter KSA | Arabisktalande Kundtjänst Vision 2030 | Call IT Dev',
      description: 'Callcenter för Saudiarabien KSA: arabisktalande modersmål, CSAT 95%, Vision 2030, från 5 $/h.',
      heroTitle: 'Callcenter för KSA — Vision 2030 Support',
      heroSubtitle: 'Premium arabisk kundtjänst för den saudiska marknaden.',
    },
    da: {
      title: 'Callcenter KSA | Arabisktalende Kundeservice Vision 2030 | Call IT Dev',
      description: 'Callcenter til Saudi-Arabien KSA: arabisktalende, CSAT 95%, Vision 2030, fra 5 $/t.',
      heroTitle: 'Callcenter til KSA — Vision 2030 Support',
      heroSubtitle: 'Premium arabisk kundeservice for det saudiske marked.',
    },
    zh: {
      title: 'KSA呼叫中心 | 沙特阿拉伯愿景2030客户服务 | Call IT Dev',
      description: 'KSA呼叫中心：阿拉伯语母语座席，CSAT 95%，符合愿景2030，5美元/小时起。',
      heroTitle: 'KSA呼叫中心 — 愿景2030支持',
      heroSubtitle: '为沙特市场提供优质阿拉伯语客户服务。',
    },
    ja: {
      title: 'KSAコールセンター | サウジアラビア ビジョン2030 | Call IT Dev',
      description: 'KSAコールセンター：アラビア語ネイティブ、CSAT 95%、ビジョン2030準拠、5$/時間〜。',
      heroTitle: 'KSAコールセンター — ビジョン2030サポート',
      heroSubtitle: 'サウジ市場向けプレミアムアラビア語カスタマーサービス。',
    },
    ko: {
      title: 'KSA 콜센터 | 사우디아라비아 비전 2030 고객 서비스 | Call IT Dev',
      description: 'KSA 콜센터: 아랍어 원어민 상담원, CSAT 95%, 비전 2030 준수, 시간당 5달러부터.',
      heroTitle: 'KSA 콜센터 — 비전 2030 지원',
      heroSubtitle: '사우디 시장을 위한 프리미엄 아랍어 고객 서비스.',
    },
    ru: {
      title: 'Колл-центр KSA | Саудовская Аравия Видение 2030 | Call IT Dev',
      description: 'Колл-центр KSA: арабоговорящие агенты, CSAT 95%, соответствие Видению 2030, от 5 $/ч.',
      heroTitle: 'Колл-центр для KSA — Поддержка Видения 2030',
      heroSubtitle: 'Премиум арабоязычное обслуживание для саудовского рынка.',
    },
  },

  // ============ SCANDINAVIA — fill missing languages (zh, ja, ko, ru, pl, it, pt, nl, ar) ============
  scandinavia: {
    zh: {
      title: '斯堪的纳维亚呼叫中心 | 北欧客户服务外包 | Call IT Dev',
      description: '斯堪的纳维亚呼叫中心外包：瑞典语、丹麦语、挪威语坐席，CSAT 95%，3美元/小时起。',
      heroTitle: '斯堪的纳维亚呼叫中心',
      heroSubtitle: '覆盖北欧三国的多语言客户服务。',
    },
    ja: {
      title: 'スカンジナビアコールセンター | 北欧カスタマーサービス | Call IT Dev',
      description: 'スカンジナビア向けコールセンター：スウェーデン語/デンマーク語/ノルウェー語、CSAT 95%、3$/時間〜。',
      heroTitle: 'スカンジナビアコールセンター',
      heroSubtitle: '北欧3カ国をカバーする多言語サポート。',
    },
    ru: {
      title: 'Колл-центр Скандинавия | Северная Европа 24/7 | Call IT Dev',
      description: 'Колл-центр для Скандинавии: шведский/датский/норвежский, CSAT 95%, от 3 $/ч.',
      heroTitle: 'Колл-центр для Скандинавии',
      heroSubtitle: 'Многоязычная поддержка для скандинавского рынка.',
    },
    pl: {
      title: 'Call Center Skandynawia | Obsługa Klienta Nordycka | Call IT Dev',
      description: 'Call center dla Skandynawii: agenci szwedzko-/duńsko-/norwesko-języczni, CSAT 95%, od 3 $/h.',
      heroTitle: 'Call Center dla Skandynawii',
      heroSubtitle: 'Wielojęzyczna obsługa rynku nordyckiego.',
    },
    it: {
      title: 'Call Center Scandinavia | Assistenza Clienti Nordica | Call IT Dev',
      description: 'Call center per la Scandinavia: agenti svedesi/danesi/norvegesi, CSAT 95%, da 3 $/h.',
      heroTitle: 'Call Center per la Scandinavia',
      heroSubtitle: 'Supporto multilingue per i mercati nordici.',
    },
    pt: {
      title: 'Call Center Escandinávia | Atendimento Nórdico | Call IT Dev',
      description: 'Call center para a Escandinávia: agentes sueco/dinamarquês/norueguês, CSAT 95%, a partir de 3 $/h.',
      heroTitle: 'Call Center para a Escandinávia',
      heroSubtitle: 'Suporte multilíngue para mercados nórdicos.',
    },
    nl: {
      title: 'Callcenter Scandinavië | Noordse Klantenservice | Call IT Dev',
      description: 'Callcenter voor Scandinavië: Zweedse/Deense/Noorse agenten, CSAT 95%, vanaf 3 $/u.',
      heroTitle: 'Callcenter voor Scandinavië',
      heroSubtitle: 'Meertalige klantenservice voor Noordse markten.',
    },
    ar: {
      title: 'مركز اتصال اسكندنافيا | خدمة عملاء شمال أوروبا | Call IT Dev',
      description: 'مركز اتصال للدول الاسكندنافية: سويدية/دنماركية/نرويجية، CSAT 95%، من 3 $/ساعة.',
      heroTitle: 'مركز اتصال لاسكندنافيا',
      heroSubtitle: 'دعم متعدد اللغات للأسواق الشمالية الأوروبية.',
    },
  },
};
